// extracted by mini-css-extract-plugin
export var card = "_4a-0";
export var content = "_4a-1";
export var contentLoading = "_4a-2";